import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

import {
    DispatcherSectorPayloadT,
    DispatchersSectorsGetListResponseT,
} from '@/core/types/dispatchers_sector.types'
import { SectorsGetListResponseT } from '../types/sectors.types'

export class DispatchersSectorsRepository {
    attachUser(user_id: number, sector_ids: number[]): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatchers_sector/attach', {
            user_id,
            sector_ids,
        })
    }

    getList(): Promise<AxiosResponse<DispatchersSectorsGetListResponseT>> {
        return http.get('/dispatcher/api/dispatcher-sectors')
    }

    getSectors(dispatcher_sector_id: number): Promise<AxiosResponse<SectorsGetListResponseT>> {
        return http.get(`/cabinet/api/sector/dispatchers_sector_id/${dispatcher_sector_id}`)
    }

    updateSector(
        dispatcher_sector_id: number,
        payload: DispatcherSectorPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/dispatchers_sector/${dispatcher_sector_id}`, payload)
    }

    createSector(payload: DispatcherSectorPayloadT): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/dispatchers_sector', payload)
    }

    deleteSector(dispatcher_sector_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/dispatchers_sector/${dispatcher_sector_id}`)
    }
}
